"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCatDisplayMap = void 0;
function buildCatDisplayMap(categories) {
    var _a, _b;
    var resultMap = {};
    for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
        var topLevel = categories_1[_i];
        resultMap[topLevel.name] = topLevel.display;
        if (((_a = topLevel.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (var _c = 0, _d = topLevel.items; _c < _d.length; _c++) {
                var secondLevel = _d[_c];
                resultMap[secondLevel.name] = secondLevel.display;
                if (((_b = secondLevel.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    for (var _e = 0, _f = secondLevel.items; _e < _f.length; _e++) {
                        var thirdLevel = _f[_e];
                        resultMap[thirdLevel.name] = thirdLevel.display;
                    }
                }
            }
        }
    }
    return resultMap;
}
exports.buildCatDisplayMap = buildCatDisplayMap;
